<template>
  <v-container fluid class="mb-4">
    <v-row column>
      <BundlesActive />
      <BundlesArchived />
    </v-row>
  </v-container>
</template>

<script setup>
import { onBeforeUnmount, onMounted } from 'vue';
import { useWorkpackagesStore } from '@/stores/workpackages';
import { useBundlesStore } from '@/stores/bundles';

const workpackagesStore = useWorkpackagesStore();
const bundlesStore = useBundlesStore();

onMounted(() => {
  // Ensure that scenario panel is not expanded in the bundles page
  workpackagesStore.toggleScenarioPanelExpanded();
});

onBeforeUnmount(() => {
  bundlesStore.selectedBundle = null;
  bundlesStore.isWorkpackagePanelExpanded = false;
});
</script>
